var map = {
	"./air-conditioner.svg": 1251,
	"./airplane.svg": 1252,
	"./airport.svg": 1253,
	"./approved.svg": 1254,
	"./aquapark.svg": 1255,
	"./arrow-answer-bubble.svg": 1256,
	"./arrow-back.svg": 1257,
	"./arrow-flight.svg": 1258,
	"./arrow-right-top.svg": 1259,
	"./arrow-right.svg": 1260,
	"./bar.svg": 1261,
	"./beach-surface-pebble.svg": 1262,
	"./beach-surface-platform.svg": 1263,
	"./beach-surface-sand-pebble.svg": 1264,
	"./beach-surface-sand.svg": 1265,
	"./beachsurface.svg": 1266,
	"./card.svg": 1267,
	"./check.svg": 1268,
	"./clock.svg": 1269,
	"./cvv.svg": 1270,
	"./double-arrow.svg": 1271,
	"./empty-hotel-map.svg": 1272,
	"./filters/clear-filters.svg": 1273,
	"./filters/filter-button.svg": 1274,
	"./filters/instant-confirm-colored.svg": 1275,
	"./filters/instant-confirm.svg": 1276,
	"./filters/search-distance.svg": 1277,
	"./filters/search-lift.svg": 1278,
	"./fire.svg": 1279,
	"./flight-direct-mobile.svg": 1280,
	"./flight-direct.svg": 1281,
	"./flight-direct__additional-mobile.svg": 1282,
	"./flight-direct__additional.svg": 1283,
	"./flight-transition-mobile.svg": 1284,
	"./flight-transition.svg": 1285,
	"./flight-transition__additional-mobile.svg": 1286,
	"./flight-transition__additional.svg": 1287,
	"./food.svg": 1288,
	"./free-cancellation-colored.svg": 1289,
	"./fuel-green.svg": 1290,
	"./fuel-white.svg": 1291,
	"./funicular.svg": 1292,
	"./gallery-empty.svg": 1293,
	"./garranty.svg": 1294,
	"./gender-female.svg": 1295,
	"./gender-male.svg": 1296,
	"./gender-unidentified.svg": 1297,
	"./gift.svg": 1298,
	"./glass.svg": 1299,
	"./gym.svg": 1300,
	"./hand-luggage.svg": 1301,
	"./heated-pool.svg": 1302,
	"./hold-luggage.svg": 1303,
	"./hotel-reply.svg": 1304,
	"./included-services.svg": 1305,
	"./included.svg": 1306,
	"./kids-club.svg": 1307,
	"./kids-menu.svg": 1308,
	"./kids-pool.svg": 1309,
	"./lightning.svg": 1310,
	"./lock.svg": 1311,
	"./logo.svg": 1312,
	"./lt-extra/bonus_insurance.svg": 1313,
	"./lt-extra/bonus_ivi.svg": 1314,
	"./luggage-wrapping.svg": 1315,
	"./man.svg": 1316,
	"./map-button.svg": 1317,
	"./map/collapse-arrows.svg": 1318,
	"./map/expand-arrows.svg": 1319,
	"./massage.svg": 1320,
	"./nanny.svg": 1321,
	"./only-lt-half.svg": 1322,
	"./parking.svg": 1323,
	"./payment-mir.svg": 1324,
	"./paymenttype.svg": 1325,
	"./plane-arrival.svg": 1326,
	"./plane.svg": 1327,
	"./private-beach.svg": 1328,
	"./rest_types/active.svg": 1329,
	"./rest_types/couples.svg": 1330,
	"./rest_types/family.svg": 1331,
	"./review-tab-selected.svg": 1332,
	"./sauna.svg": 1333,
	"./search-sorting.svg": 1334,
	"./searcher-empty-request.svg": 1335,
	"./searcher-filtered-empty.svg": 1336,
	"./sidebar-bottom-triangle.svg": 1337,
	"./sidebar-menu-active.svg": 1338,
	"./sign_additional.svg": 1339,
	"./ski-in-ski-out.svg": 1340,
	"./social-fb.svg": 1341,
	"./social-share.svg": 1342,
	"./social-vk.svg": 1343,
	"./special.svg": 1344,
	"./success_additional.svg": 1345,
	"./swimming-pool.svg": 1346,
	"./thumbs-up.svg": 1347,
	"./wave.svg": 1348,
	"./wifi.svg": 1349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 750;